import { SET_TAP_TO_PAY_TIPS } from '../../actionTypes/tap2Pay'

export const setTap2PayTips = value => ({ type: SET_TAP_TO_PAY_TIPS, value })
